__turbopack_context__.v({
  "error": "InfoBlock-module__0VioPG__error",
  "info": "InfoBlock-module__0VioPG__info",
  "infoBlock": "InfoBlock-module__0VioPG__infoBlock",
  "infoIcon": "InfoBlock-module__0VioPG__infoIcon",
  "infoText": "InfoBlock-module__0VioPG__infoText",
  "neutral": "InfoBlock-module__0VioPG__neutral",
  "success": "InfoBlock-module__0VioPG__success",
  "warning": "InfoBlock-module__0VioPG__warning",
});
